(() => {
  const SELECTOR = '[data-anchor-tabs]';

  function scrollTabIntoView(nav, tab, behavior = 'smooth') {
    if (!nav || !tab || nav.scrollWidth <= nav.clientWidth) return;

    const navRect = nav.getBoundingClientRect();
    const tabRect = tab.getBoundingClientRect();
    const current = nav.scrollLeft;
    const left = tabRect.left - navRect.left + current;
    const target = left + tabRect.width / 2 - nav.clientWidth / 2;
    const max = Math.max(0, nav.scrollWidth - nav.clientWidth);

    nav.scrollTo({ left: Math.max(0, Math.min(max, target)), behavior });
  }

  function getEntries(root) {
    return [...root.querySelectorAll('[data-anchor-tab]')].map((tab) => {
      const key = tab.dataset.anchorTab;
      const target = document.getElementById(key);
      const wrapper = target?.closest('.shopify-section') || target;
      const item = tab.closest('[data-anchor-tab-item]');

      if (item) item.hidden = !target;

      return { tab, key, target, wrapper, item };
    });
  }

  function setActive(root, key, options = {}) {
    const { updateHistory = true, focus = false, behavior = 'smooth' } = options;
    const entries = getEntries(root).filter((entry) => entry.target && entry.wrapper);
    if (!entries.length) return;

    const activeEntry = entries.find((entry) => entry.key === key) || entries[0];
    const nav = root.querySelector('.anchor-tabs__nav');

    entries.forEach((entry) => {
      const isActive = entry === activeEntry;

      entry.tab.classList.toggle('is-active', isActive);
      entry.tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      entry.tab.tabIndex = isActive ? 0 : -1;

      entry.target.setAttribute('role', 'tabpanel');
      entry.target.setAttribute('aria-labelledby', entry.tab.id);
      entry.target.setAttribute('aria-hidden', isActive ? 'false' : 'true');

      if (entry.wrapper !== root.closest('.shopify-section')) {
        entry.wrapper.hidden = !isActive;
      }
    });

    scrollTabIntoView(nav, activeEntry.tab, behavior);
    if (focus) activeEntry.tab.focus({ preventScroll: true });

    if (updateHistory) {
      const url = `${window.location.pathname}${window.location.search}#${activeEntry.key}`;
      history.replaceState(null, '', url);
    }
  }

  function moveFocus(root, currentTab, direction) {
    const available = getEntries(root)
      .filter((entry) => entry.target)
      .map((entry) => entry.tab);

    if (!available.length) return;

    const index = available.indexOf(currentTab);
    if (index === -1) return;

    let nextIndex = index;
    if (direction === 'next') nextIndex = (index + 1) % available.length;
    if (direction === 'prev') nextIndex = (index - 1 + available.length) % available.length;
    if (direction === 'first') nextIndex = 0;
    if (direction === 'last') nextIndex = available.length - 1;

    const nextTab = available[nextIndex];
    setActive(root, nextTab.dataset.anchorTab, { focus: true });
  }

  function refresh(root) {
    const entries = getEntries(root).filter((entry) => entry.target);
    if (!entries.length) return;

    const hashKey = window.location.hash.replace('#', '');
    const current = entries.find((entry) => entry.tab.getAttribute('aria-selected') === 'true');
    const hashEntry = entries.find((entry) => entry.key === hashKey);
    const active = hashEntry || current || entries[0];

    setActive(root, active.key, { updateHistory: false, behavior: 'auto' });
  }

  function init(root) {
    if (root.dataset.anchorTabsReady !== 'true') {
      root.dataset.anchorTabsReady = 'true';

      root.addEventListener('click', (event) => {
        const tab = event.target.closest('[data-anchor-tab]');
        if (!tab || !root.contains(tab)) return;

        const target = document.getElementById(tab.dataset.anchorTab);
        if (!target) return;

        event.preventDefault();
        setActive(root, tab.dataset.anchorTab);
      });

      root.addEventListener('keydown', (event) => {
        const tab = event.target.closest('[data-anchor-tab]');
        if (!tab || !root.contains(tab)) return;

        if (event.key === 'ArrowRight') {
          event.preventDefault();
          moveFocus(root, tab, 'next');
        } else if (event.key === 'ArrowLeft') {
          event.preventDefault();
          moveFocus(root, tab, 'prev');
        } else if (event.key === 'Home') {
          event.preventDefault();
          moveFocus(root, tab, 'first');
        } else if (event.key === 'End') {
          event.preventDefault();
          moveFocus(root, tab, 'last');
        }
      });
    }

    refresh(root);
  }

  function boot(scope = document) {
    scope.querySelectorAll(SELECTOR).forEach(init);
    if (scope.matches?.(SELECTOR)) init(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => boot());
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', () => boot());

  document.addEventListener('shopify:section:select', (event) => {
    document.querySelectorAll(SELECTOR).forEach((root) => {
      const entry = getEntries(root).find((item) => item.wrapper === event.target);
      if (entry) setActive(root, entry.key, { updateHistory: false, behavior: 'auto' });
    });
  });
})();
